import { createAction, props } from '@ngrx/store';

import { PortfolioAssetDetailsResponse } from '../../models';

export const SET_IS_WEIGHT_ACTIVE = '[Portfolio Holdings Resolution] - Set Holdings Resolution isWeightActive';
export const SET_ALL_PORTFOLIO_ASSET_DETAILS_RESPONSES = '[Portfolio Holdings Resolution] - Set all portfolio asset details responses';

export const setAllPortfolioAssetDetailsResponses = createAction(
	SET_ALL_PORTFOLIO_ASSET_DETAILS_RESPONSES,
	props<{ portfolioAssetDetailsResponses: PortfolioAssetDetailsResponse[] }>()
);

